import { ligainicial } from "./rutainicial.js";

const ligabase = ligainicial + "2026/Lic/C";

export const licitacionesVigentes = [
    {
        // CONVOCATORIA NUM# 002
        'numConvocatoria' : 'Convocatoria No. 002/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N5-2026.',
        'vigencia' : '2 al 13 de marzo de 2026.',
        'descripcionProcedimiento' : 'Pavimentación con concreto hidráulico de Av. Madero (Av. Juárez - Blvd. Río de las Avenidas), en el municipio de Pachuca de Soto.; ubicada en Varias localidades del Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligabase }2/N5/N5.rar`,
        'start' : '2026-03-02',
        'end' : '2026-03-13',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N4-2026.',
        'vigencia' : '2 al 13 de marzo de 2026.',
        'descripcionProcedimiento' : 'Rehabilitación de la C.E. Atlapexco - Huejutla de Reyes del Km 8+500 al 18+360, en el municipio de Atlapexco.; ubicada en la localidad y Municipio de Atlapexco, Estado de Hidalgo',
        'urlAnexos' : `${ ligabase }2/N4/N4.rar`,
        'start' : '2026-03-02',
        'end' : '2026-03-13',
        'procedimiento' : 'Licitación Pública',
    },
]